import React from 'react';
import { loadCurrentState } from '../storage';
import { useCheckboxWithTimestamp } from '../hooks/useCheckboxWithTimestamp';

export const useParentsStatus = () => {
  const saved = loadCurrentState();
  const parents = saved?.parents || {};
  const states = [
    parents.preemieStatus,
    parents.explanations,
    parents.giveBloodConsent,
  ];
  const checked = states.filter(Boolean).length;
  return { checked, total: 3 };
};

const Parents: React.FC = () => {
  const saved = loadCurrentState();

  const [preemieStatus, setPreemieStatus] = useCheckboxWithTimestamp(
    'parents',
    'preemieStatus',
    saved?.parents?.preemieStatus || false
  );
  const [explanations, setExplanations] = useCheckboxWithTimestamp(
    'parents',
    'explanations',
    saved?.parents?.explanations || false
  );
  const [giveBloodConsent, setGiveBloodConsent] = useCheckboxWithTimestamp(
    'parents',
    'giveBloodConsent',
    saved?.parents?.giveBloodConsent || false
  );

  return (
    <div className="section-content-wrapper" style={{ padding: '20px', direction: 'rtl' }}>
      <div className="checkbox-group">
        <label className="checkbox-label">
          <input
            type="checkbox"
            checked={preemieStatus}
            onChange={(e) => setPreemieStatus(e.target.checked)}
          />
          <span>עדכון הורים על מצב הפג</span>
        </label>
      </div>

      <div className="checkbox-group">
        <label className="checkbox-label">
          <input
            type="checkbox"
            checked={explanations}
            onChange={(e) => setExplanations(e.target.checked)}
          />
          <span>הסבר על קולוסטרום וחלב אם תרומה לפי סטטוס cmv</span>
        </label>
      </div>

      <div className="checkbox-group">
        <label className="checkbox-label">
          <input
            type="checkbox"
            checked={giveBloodConsent}
            onChange={(e) => setGiveBloodConsent(e.target.checked)}
          />
          <span>החתמה על הסכמה למתן דם</span>
        </label>
      </div>
    </div>
  );
};

export default Parents;
